import { render, staticRenderFns } from "./LeaveProject.vue?vue&type=template&id=32f5d780&"
import script from "./LeaveProject.vue?vue&type=script&lang=js&"
export * from "./LeaveProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports